document.addEventListener('DOMContentLoaded', () => {
  const dots = document.querySelectorAll('.dot');
  const contents = document.querySelectorAll('.content');  
  
  dots.forEach((dot) => {    
    dot.addEventListener('click', () => {
      const id = dot.getAttribute('data-id');
  
      dots.forEach((d) => {
        d.classList.remove('active');
      });
  
      dot.classList.add('active');
  
      contents.forEach((content) => {
        if (content.getAttribute('data-id') === id) {
          if (!content.classList.contains('active')) {
            content.classList.add('active');
            content.style.opacity = 1;
          }
        } else {
          if (content.classList.contains('active')) {
            content.style.opacity = 0;
            content.classList.remove('active');
          }
        }
      });
    });
  });

  // $(window).resize(function() {
    const carousel = document.querySelector('.testimonial-reel-carousel');
    const cards = carousel.querySelectorAll('.test-component-carousel');
    
    let maxHeight = 0;
    cards.forEach(card => {
      if (card.offsetHeight > maxHeight) {
        maxHeight = card.offsetHeight;
      }
    });
    
    cards.forEach(card => {
      card.style.height = `${maxHeight}px`;
    });
  // });
  
});